var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('ErrorPage',{on:{"goBack":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }